import { render, staticRenderFns } from "./ClaimsStatisticsPage.vue?vue&type=template&id=5be776cd&scoped=true&"
import script from "./ClaimsStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./ClaimsStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsStatisticsPage.vue?vue&type=style&index=0&id=5be776cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be776cd",
  null
  
)

export default component.exports